import { Link } from "react-router-dom";
import { MessageCircle, Twitter, Instagram, Youtube } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "Problem", id: "#problem" },
  { label: "How It Works", id: "#how-it-works" },
  { label: "Pricing", id: "#pricing" },
  { label: "FAQ", id: "#faq" },
  { label: "Contact", id: "#contact" },
];

const SOCIALS = [
  { label: "X / Twitter", icon: Twitter, test: "footer-social-x" },
  { label: "Instagram Atelier", icon: Instagram, test: "footer-social-instagram" },
  { label: "YouTube Masterclasses", icon: Youtube, test: "footer-social-youtube" },
  { label: "Creator Community", icon: MessageCircle, test: "footer-social-community" },
];

export default function Footer() {
  const go = (id) => (e) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <>
      <footer data-testid="page-footer" className="relative border-t border-white/10 bg-[#04070D]/90 px-6 pb-10 pt-16">
        <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
              <span className="text-lg font-extrabold tracking-tight text-white">GRAPHO</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Original designs for Etsy sellers — crafted by humans, delivered overnight.
            </p>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
              Every design crafted by human hands
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
              Navigate
            </p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.id}>
                  <a
                    href={l.id}
                    onClick={go(l.id)}
                    className="text-sm text-slate-400 transition-colors duration-300 hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
              Follow the Atelier
            </p>
            <ul className="mt-5 space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.test}>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    aria-label={s.label}
                    data-testid={s.test}
                    className="inline-flex items-center gap-2.5 text-sm text-slate-400 transition-colors duration-300 hover:text-white"
                  >
                    <s.icon className="h-4 w-4" />
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 flex max-w-6xl flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row">
          <p data-testid="footer-copyright-statement" className="text-xs text-slate-600">
            © {new Date().getFullYear()} Grapho. All rights reserved.
          </p>
          <div data-testid="footer-legal-links" className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-xs text-slate-500 transition-colors hover:text-amber-300"
            >
              Terms of Service
            </Link>
            <Link
              to="/terms#cancellation-policy"
              data-testid="footer-cancellation-link"
              className="text-xs text-slate-500 transition-colors hover:text-amber-300"
            >
              Cancellation Policy
            </Link>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-600">
            Designed overnight, delivered by 8 AM
          </p>
        </div>
      </footer>
    </>
  );
}
